import React from 'react';

function ChatList({ chatrooms, selectedChat, onChatSelect, loading, error, onCreateChatRoom, onRefresh, hasNewChats }) {
    // Use real chatrooms data from API
    const contacts = chatrooms;
    
    return (
        <div className="h-full flex flex-col bg-white rounded-l-2xl">
            {/* Header */}
            <div className="px-6 py-6 border-b border-gray-200 bg-gray-50 rounded-tl-2xl flex-shrink-0">
                <div className="flex items-center justify-between mb-3">
                    <h2 className="text-lg font-semibold text-gray-800">Support Conversations</h2>
                    <button
                        onClick={onCreateChatRoom}
                        className="px-4 py-2 bg-blue-500 text-white text-sm font-medium rounded-lg hover:bg-blue-600 transition-all duration-200 hover:shadow-md hover:-translate-y-0.5"
                    >
                        + Create Chat
                    </button>
                </div>
                {onRefresh && (
                    <div className="flex items-center justify-between">
                        <button
                            onClick={onRefresh}
                            className={`flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-lg transition-all duration-200 ${
                                hasNewChats 
                                    ? 'bg-green-100 text-green-700 hover:bg-green-200' 
                                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                            }`}
                        >
                            <svg className={`w-4 h-4 ${hasNewChats ? 'animate-spin' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                            </svg>
                            {hasNewChats ? 'New chats available - Click to refresh' : 'Refresh'}
                        </button>
                    </div>
                )}
            </div>
            
            {/* Contact List */}
            <div className="flex-1 overflow-y-auto py-2">
                {loading ? (
                    <div className="p-5 text-center text-gray-600">Loading conversations...</div>
                ) : error ? (
                    <div className="p-5 text-center text-red-600">{error}</div>
                ) : contacts.length === 0 ? (
                    <div className="p-5 text-center text-gray-600">No conversations found</div>
                ) : (
                    <div className="px-2">
                        {contacts.map((contact) => (
                            <div 
                                key={contact.id} 
                                onClick={() => onChatSelect(contact)}
                                className={`flex items-start p-5 mx-2 mb-2 rounded-xl cursor-pointer transition-all duration-200 hover:bg-gray-50 hover:shadow-md hover:-translate-y-0.5 ${
                                    selectedChat?.id === contact.id ? 'bg-gray-50 shadow-sm' : 'bg-white'
                                }`}
                            >
                                {/* Avatar */}
                                <div className="relative mr-4 flex-shrink-0">
                                    <div 
                                        className="w-13 h-13 rounded-full flex items-center justify-center text-white font-semibold text-lg shadow-sm"
                                        style={{ backgroundColor: contact.avatarColor }}
                                    >
                                        {contact.avatar}
                                    </div>
                                    {contact.isOnline && (
                                        <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 border-2 border-white rounded-full"></div>
                                    )}
                                </div>
                                
                                {/* Contact Info */}
                                <div className="flex-1 min-w-0 relative">
                                    <div className="font-semibold text-gray-800 text-base mb-1">
                                        {contact.name}
                                    </div>
                                    <div className="text-sm text-gray-500 mb-1">
                                        {contact.role}
                                        {contact.timezone && (
                                            <span className="ml-2 text-xs text-blue-600 bg-blue-100 px-2 py-0.5 rounded-full">
                                                {contact.timezone}
                                            </span>
                                        )}
                                    </div>
                                    <div className="text-sm text-gray-600 mb-1 truncate max-w-48">
                                        {contact.lastMessage}
                                    </div>
                                    <div className="text-xs text-gray-400">
                                        {contact.lastMessageTime}
                                    </div>
                                    
                                    {/* Unread Badge */}
                                    {contact.unreadCount > 0 && (
                                        <div className="absolute top-0 right-0 bg-red-500 text-white text-xs font-semibold rounded-full w-6 h-6 flex items-center justify-center shadow-sm">
                                            {contact.unreadCount}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default ChatList; 